import React from "react"
import Link from "gatsby-link";
// import menu from '../scripts/menu.js';
import '../styles/index.scss';
import '../styles/utils.scss';


import Banner from '../components/Banner';
import Button from '../components/Button';
import Content from '../components/Content';
import Client from '../components/Client';
import Footer from '../components/Footer';
import Form from '../components/Form';
import HalfHero from '../components/HalfHero';
import Header from '../components/Header';
import Hero from '../components/Hero';
import IconList from '../components/IconList';
import Testimonial from '../components/Testimonial';
import Testimonials from '../components/Testimonials';

import boxing from '../img/clients/boxing.jpg';
import smallGroupTraining from '../img/clients/small-group-training.jpg';

export default () => 
  <div>
    <Banner>
      <h1>About Personal Trainer Jerron Torbert</h1>
    </Banner>
    <Content>
      <h3>“Your goals, my passion!”</h3>
      <p>My interest into becoming a personal trainer/nutritionist began when I started to live a healthy lifestyle and people inquired as to how I built my physique and saw my work ethic in the gym. In my youth I participated in sports including baseball and boxing being a “Golden Gloves” champion and continued to keep a regular workout program afterwards.</p>
      <p>My passion now is to help others experience the same benefits I’ve experienced through regular exercise and a healthy diet. Obtaining my certifications in Personal Training and Nutrition Specialist from NASM (National Association of Sports Medicine), two years of personal training experience (11 months at 24 Hour Fitness and 1 year as a private trainer at Will Power Fitness in DTC), and 10 years in the food industry as a Chef has equipped me with the tools to help my clients live healthier lifestyles and obtain their fitness goals.</p>
      <p>With these tools I personally “CustomFIT” fitness and nutrition to fit each client's specific goals and needs. I continue to learn and add to my knowledge/value as a trainer and implement my strategies in my own training to ensure the most effective techniques to drive results in the programs I design for each of my clients.</p>
      <Button to={'#get-started'} type={'href'}>Get Started!</Button>
    </Content>
    <IconList 
      title="Personal Training Programs"
      columns="2">
      <li>
        <h3>Lean &amp; Mean</h3>
        <p>Time to get shredded! Lean &amp; Mean is a high intensity designed program to transform your physique. This program is great for both men and women!</p>
        <h4>Includes:</h4>
        <ul>
          <li>Fat destroying cardio routines</li>
          <li>Video demonstrations</li>
          <li>Nutritional and supplementation guidelines</li>
        </ul>
        <Button href={'#get-started'}>Get Started!</Button>
      </li>
      <li>
        <h3>Ripped Core</h3>
        <p>Wear that swimsuit with confidence! Ripped Core is a great program for men and women!</p>
        <h4>Includes:</h4>
        <ul>
          <li>Ab specific exercise to work all areas</li>
          <li>Video demonstrations</li>
          <li>Nutritional guideline</li>
        </ul>
        <Button href={'#get-started'}>Get Started!</Button>
      </li>
      <li>
        <h3>Mass Gains</h3>
        <p>Build a head turning physique! Mass Gains is trainer Jerron Torbert's favorite routine.</p>
        <h4>Includes:</h4>
        <ul>
          <li>Fundamental exercises, rep ranges, sets, and rest periods</li>
          <li>Key high intensity techniques</li>
          <li>Video demonstrations</li>
          <li>Nutritional and supplementation guidelines</li>
        </ul>
        <Button href={'#get-started'}>Get Started!</Button>
      </li>
      <li>
        <h3>Strength Driven Training</h3>
        <p>Time to move some weight! Trainer Jerron Torbert knows how to increase strength: he has a 1350 lb total in the Powerlifting movements (the Squat, Benchpress, and Deadlift) at 190 lbs</p>
        <h4>Includes:</h4>
        <ul>
          <li>Proven strength techniques</li>
          <li>Fundamental exercises, rep ranges, sets, and rest periods</li>
          <li>Strength specific nutritional plan</li>
          <li>Supplementation guideline</li>
        </ul>
        <Button href={'#get-started'}>Get Started!</Button>
      </li>
    </IconList>
  </div>



// WEBPACK FOOTER //
// ./src/pages/about.js